<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="E-mail">
        <input class="form-input" v-model="config.auth.email">
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.token">
      </form-group>
      <form-group label="Código da loja">
        <input class="form-input" v-model="config.auth.storeCode">
      </form-group>
    </div>
    
    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>


    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>
  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'keepRunning'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'keepRunning',
      config: {
        auth: {
          environment: 'sandbox',
          sandboxUrl: 'https://teste.conectala.com.br',
          productionUrl: 'https://keeprunningbrasil.conectala.com.br',
          subModuleIdentifier: 'keepRunning',
          email: null,
          token: null,
          storeCode: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        },
        webhook: {
          sellerId: null
        }
      }
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// KeepRunning.vue?7724ba1b